import React from 'react'
import Lottie from 'react-lottie'

import animationData from 'assets/lottiefiles/no-data.json'
import { generateDefaultOptions, styles } from './config'

const defaultOptions = generateDefaultOptions(animationData)

const NoData = () => {
  return (
    <div style={styles}>
      <Lottie
        isClickToPauseDisabled
        options={defaultOptions}
        height={400}
        width={400}
      />
    </div>
  )
}

export default NoData
